





















































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Validator } from 'vee-validate';

import { ValidationObserver, ValidationProvider } from 'vee-validate';

import { IPayment } from '@/interfaces/Payment';
import { ECardStep, EPaymentMethod, EPaymentMethodTypes } from '@/helpers/enums';
import { Payment } from '@/classes/Checkout/Payment';

import Field from '@/shared/components/Field/Field.vue';
import Button from '@/shared/components/Button/Button.vue';
import CreditCardField from '../CreditCardField.vue';
import NewCreditCardForm from '../NewCreditCardForm.vue';
import LabelDiscount from '@/shared/components/Labels/LabelDiscount.vue';

const AppModule = namespace('App');
const BehaviorModule = namespace('App/Behavior');
const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    Field,
    Button,
    CreditCardField,
    NewCreditCardForm,
    LabelDiscount,
  }
})
export default class SingleCreditCardForm extends Vue {
  public $refs!: {
    observer: any,
    creditCardField: CreditCardField,
    newCreditCardForm: NewCreditCardForm,
    [x: string]: any;
  };

  private form = {
    newCreditCard: {},
  };

  @Prop()
  private readonly creditCardInstallments: [];

  @Prop()
  private readonly creditCardSelectedInstallment: any;

  private validator = new Validator();

  private creditCardErrors: any = this.validator.errors;

  @AppModule.Mutation
  private setPaymentMethodSelected: Function;

  @BehaviorModule.Getter('isCaptchaValid')
  private isCaptchaValid: Function;

  @BehaviorModule.State
  private canPay: boolean;

  @CheckoutModule.Getter('selectedOfferPayment')
  private payment: Payment;

  @CheckoutModule.Getter('selectedOfferPaymentCardSelected')
  private selectedPaymentCard: any;

  @CheckoutModule.Getter('selectedOfferDiscountByPaymentMethod')
  private discountByPaymentMethod: any;

  private get creditCardsTreated(): any {
    return this.payment.cards.options;
  }

  private get showLabelDiscount() {
    return this.discountByPaymentMethod(EPaymentMethod.creditCard);
  }

  private get stepCreditCardSelected() {
    return this.payment && this.payment.getPaymentMethod(EPaymentMethod.creditCard) && this.payment.getPaymentMethod(EPaymentMethod.creditCard).step;
  }

  private get isStepNewCard() {
    return this.stepCreditCardSelected === ECardStep.new;
  }

  private sendCardDigits() {
    this.$emit('sendCardDigits');
  }

  private setCardStep(cardStep: any) {
    this.$emit('setCardStep', cardStep);
  }

  private selectPaymentCard(payload: any) {
    this.$emit('setCreditCard', payload);
  }

  private setPaymentCardInstallment(payload: any) {
    this.$emit('setCardInstallment', payload);
  }

  private selectInstallment(installmentNumber: number) {
    this.$emit('setCardInstallment', installmentNumber);
  }

  private showNewcreditCardForm(payload: any) {
    this.payment.setPaymentMethodField(EPaymentMethod.creditCard, 'step', payload);
  }

  private closeModal() {
    this.$emit('closeModal');
  }

  public async validateForm() {
    let valid: boolean = false;

    if (this.isStepNewCard) {
      valid = await this.$refs.newCreditCardForm.validateForm();
    } else {
      valid = await this.$refs.creditCardField.validateForm();
    }

    return valid;
  }

  mounted() {
    this.setPaymentMethodSelected(EPaymentMethodTypes.creditCard);

    if (this.creditCardsTreated && this.creditCardsTreated.length === 0) {
      this.showNewcreditCardForm(ECardStep.new);
    } else {
      this.showNewcreditCardForm(ECardStep.select);
    }
  }
}
